import React, { useState } from "react";
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact: React.FC = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        message: "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        const templateParams = {
            from_name: `${formData.firstName} ${formData.lastName}`,
            from_email: formData.email,
            message: formData.message,
        };

        emailjs.send(
            'service_8b5jf49',  // Replace with your EmailJS Service ID
            'template_djn93gj', // Replace with your EmailJS Template ID
            templateParams,
            'UomUdubQI35pd9sTm'  // Replace with your EmailJS Public Key
        )
        .then((response) => {
            console.log('Email sent successfully:', response);
            alert("Message sent successfully!");
        })
        .catch((error) => {
            console.error('Error sending email:', error);
            alert("Failed to send message. Please try again.");
        });
    };

    return (
        <div className="contact-container">
            <div className="contact-content">
                <div className="contact-Info">
                    <h1>Contact US</h1>
                    <label>
                        ekene.obiesie@consistencyAI.net
                        PO box 831034 Richardson, TX 75080
                    </label>
                </div>

                <div className="contactBox-container">
                    <form onSubmit={handleSubmit}>
                        <label>Name <span className="required">(required)</span></label>
                        <div className="name-fields">
                            <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required />
                            <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required />
                        </div>

                        <label>Email <span className="required">(required)</span></label>
                        <input type="email" name="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} required />

                        <label>Message <span className="required">(required)</span></label>
                        <textarea name="message" placeholder="Write your message" value={formData.message} onChange={handleChange} required />

                        <button type="submit">Send</button>
                    </form>
                </div>
                <div className="Footer"></div>
            </div>
        </div>
    );
};

export default Contact;
